
<form
  *ngIf="isEditting"
  class="address-info"
  [ngClass]="{ validate: showError, 'child-mode-form': childMode }"
  name="form"
  #form="ngForm"
>
  <table class="table no-bordered no-wrap-label">
    <tbody>
      <tr>
        <td class="text-grey">Email</td>
        <td class="text-left">
          <input
            type="text"
            class="form-control"
            [value]="addressInfo.email"
            readonly
          />
        </td>
      </tr>
      <tr>
        <td class="text-grey">UserName
          <span class="text-red">*</span>
        </td>
        <td class="text-left">
            <div class="row">
              <div class="col-auto" >
                <input
                  type="text"
                  class="form-control"
                  name="firstName"
                  [(ngModel)]="addressInfo.firstName"
                  #firstName="ngModel"
                  required
                />
                <span>
                </span>
                <div class="errors-group" *ngIf="showError && firstName.errors">
                  <small class="error-message" *ngIf="firstName.errors?.required">
                    {{'VALIDATIONS.REQUIRED' | translate}}
                  </small>
                </div>
                <div class="errors-group" *ngIf="showError && firstName.errors">
                  <small class="error-message" *ngIf="firstName.errors.pattern">
                    {{'VALIDATIONS.INVALID' | translate}}
                  </small>
                </div>
              </div>
              <div class="col-auto" *ngIf="addressInfo?.country!=='JP'">
                <input
                  type="text"
                  class="form-control uppercase"
                  name="middleName"
                  [(ngModel)]="addressInfo.middleName"
                  #middleName="ngModel"
                />
                <div class="errors-group" *ngIf="showError && middleName.errors">
                  <small class="error-message" *ngIf="middleName.errors.pattern">
                    {{'VALIDATIONS.INVALID' | translate}}
                  </small>
                </div>

              </div>
              <div class="col-auto">
                <input
                  type="text"
                  class="form-control uppercase"
                  name="lastName"
                  [(ngModel)]="addressInfo.lastName"
                  #lastName="ngModel"
                  required
                />
                <div class="errors-group" *ngIf="showError && lastName.errors">
                  <small class="error-message" *ngIf="lastName.errors?.required">
                    {{'VALIDATIONS.REQUIRED' | translate}}
                  </small>
                </div>
                <div class="errors-group" *ngIf="showError && lastName.errors">
                  <small class="error-message" *ngIf="lastName.errors.pattern">
                    {{'VALIDATIONS.INVALID' | translate}}
                  </small>
                </div>
              </div>
            </div>
        </td>
      </tr>
      <tr *ngIf="addressInfo?.country === 'JP'">
        <td class="text-grey">Japanese Name
          <span class="text-red">*</span>
        </td>
        <td class="text-left">
            <div class="row">
              <div class="col-auto">
                <input
                  type="text"
                  class="form-control"
                  name="firstNameJP"
                  [(ngModel)]="addressInfo.firstNameJP"
                  #firstNameJP="ngModel"
                  pattern="{{regexCharacter.FULL_KATAKANA}}"
                  required
                />
                <div class="errors-group" *ngIf="showError && firstNameJP.errors">
                  <small class="error-message" *ngIf="firstNameJP.errors?.required">
                    {{'VALIDATIONS.REQUIRED' | translate}}
                  </small>
                </div>
                <div class="errors-group" *ngIf="showError && firstNameJP.errors">
                  <small class="error-message" *ngIf="firstNameJP.errors.pattern">
                    {{'VALIDATIONS.FULL_KATAKANA' | translate}}
                  </small>
                </div>
              </div>
              <div class="col-auto">
                <input
                  type="text"
                  class="form-control"
                  name="lastNameJP"
                  [(ngModel)]="addressInfo.lastNameJP"
                  #lastNameJP="ngModel"
                  pattern="{{regexCharacter.FULL_KATAKANA}}"
                  required
                />
                <div class="errors-group" *ngIf="showError && lastNameJP.errors?.required">
                  <small class="error-message">
                    {{'VALIDATIONS.REQUIRED' | translate}}
                  </small>
                </div>
                <div class="errors-group" *ngIf="showError && lastNameJP.errors">
                  <small class="error-message" *ngIf="lastNameJP.errors.pattern">
                    {{'VALIDATIONS.FULL_KATAKANA' | translate}}
                  </small>
                </div>
              </div>
            </div>
        </td>
      </tr>
      <tr>
        <td class="text-grey">Phone No.
          <span class="text-red">*</span>
        </td>
        <td class="text-left">
            <div class="row">
              <div class="col-auto">
                <input
                  type="text"
                  pattern="{{regexCharacter.PHONE}}"
                  class="form-control"
                  name="phone"
                  #phone="ngModel"
                  [(ngModel)]="addressInfo.phone"
                  required
                />
                <div class="errors-group" *ngIf="showError && phone.errors">
                  <small class="error-message" *ngIf="phone.errors?.required">
                    {{'VALIDATIONS.REQUIRED' | translate}}
                  </small>
                </div>
                <div class="errors-group" *ngIf="showError && phone.errors">
                  <small class="error-message" *ngIf="phone.errors.pattern">
                    {{'VALIDATIONS.INVALID' | translate}}
                  </small>
                </div>
              </div>
            </div>
        </td>
      </tr>
      <tr>
        <td class="text-grey">DOB
          <span class="text-red">*</span>
        </td>
        <td class="text-left">
          <!-- [maxDate]="dateCondition.max" -->
            <p-calendar
              [(ngModel)]="addressInfo.dob"
              name="dob"
              (onInput)="validateDateOfBirth()"
              dateFormat="dd/mm/yy"
              appendTo="body"
              inputStyleClass="fx-calendar"
              panelStyleClass="fx-ui-datepicker"
              showIcon="true"
              #dob="ngModel"
              icon="fa fa-calendar"
              required
            ></p-calendar>
            <div class="errors-group" *ngIf="showError && dob.errors">
              <small class="error-message" *ngIf="dob.errors.required">
                {{'VALIDATIONS.REQUIRED' | translate}}
              </small>
            </div>
            <div class="errors-group" *ngIf="showError && !validateDateOfBirth()">
              <small class="error-message">
                {{'VALIDATIONS.AGE_UNDER_18' | translate}}
              </small>
            </div>
        </td>
      </tr>
      <tr>
        <td class="text-grey">Gender
          <span class="text-red">*</span>
        </td>
        <td class="text-left">
           <div class="row">
              <div class="col-auto">
                <select
                  class="form-control"
                  name="gender"
                  [(ngModel)]="addressInfo.gender"
                >
                  <option [ngValue]="1">Male</option>
                  <option [ngValue]="0">Female</option>
                </select>
              </div>
            </div>
        </td>
      </tr>
      <tr>
        <td class="text-grey">Country
          <span class="text-red">*</span>
        </td>
        <td class="text-left">
            <div class="row">
              <div class="col-auto">
                <p-dropdown
                  name="country"
                  styleClass="form-control text-white"
                  [options]="countries"
                  [(ngModel)]="addressInfo.country"
                  #country="ngModel"
                  required
                  [filter]="true"
                ></p-dropdown>
                <div class="errors-group" *ngIf="showError && country.errors">
                  <small class="error-message" *ngIf="country.errors?.required">
                    {{'VALIDATIONS.REQUIRED' | translate}}
                  </small>
                </div>
              </div>
            </div>
        </td>
      </tr>
      <tr>
        <td class="text-grey">Postal/Zip Code
          <span class="text-red">*</span>
        </td>
        <td class="text-left">
            <div class="row">
              <div class="col-auto">
                <input
                  type="text"
                  class="form-control"
                  name="zipCode"
                  #zipCode="ngModel"
                  [(ngModel)]="addressInfo.zipCode"
                  required
                />
                <div class="errors-group" *ngIf="showError && zipCode.errors">
                  <small class="error-message" *ngIf="zipCode.errors?.required">
                    {{'VALIDATIONS.REQUIRED' | translate}}
                  </small>
                </div>
              </div>
            </div>
        </td>
      </tr>
      <tr>
        <td class="text-grey">Province/City
          <span class="text-red">*</span>
        </td>
        <td class="text-left">
            <div class="row">
              <div class="col-auto">
                <input
                  type="text"
                  class="form-control"
                  name="city"
                  #city="ngModel"
                  [(ngModel)]="addressInfo.city"
                  required
                />
                <div class="errors-group" *ngIf="showError && city.errors">
                  <small class="error-message" *ngIf="city.errors?.required">
                    {{'VALIDATIONS.REQUIRED' | translate}}
                  </small>
                </div>
              </div>
            </div>
        </td>
      </tr>
      <tr>
        <td class="text-grey">Street
          <span class="text-red">*</span>
        </td>
        <td class="text-left">
            <div class="row">
              <div class="col col-md-6">
                <input
                  type="text"
                  class="form-control"
                  name="street"
                  [(ngModel)]="addressInfo.street"
                  #street="ngModel"
                  required

                />
                <div class="errors-group" *ngIf="showError && street.errors">
                  <small class="error-message" *ngIf="street.errors?.required">
                    {{'VALIDATIONS.REQUIRED' | translate}}
                  </small>
                </div>
              </div>
            </div>
        </td>
      </tr>
      <tr>
        <td class="text-grey">Address
          <span class="text-red">*</span>
        </td>
        <td class="text-left">
            <div class="row">
              <div class="col col-md-6">
                <input
                  type="text"
                  class="form-control"
                  name="address"
                  [(ngModel)]="addressInfo.address"
                  #address="ngModel"
                  required

                />
                <div class="errors-group" *ngIf="showError && address.errors">
                  <small class="error-message" *ngIf="address.errors?.required">
                    {{'VALIDATIONS.REQUIRED' | translate}}
                  </small>
                </div>
              </div>
            </div>
        </td>
      </tr>
      <tr>
        <td class="text-grey">Building Name</td>
        <td class="text-left">
            <div class="row">
              <div class="col col-md-6">
                <input
                  type="text"
                  class="form-control"
                  name="building"
                  [(ngModel)]="addressInfo.building"
                  #building="ngModel"
                />
              </div>
            </div>
        </td>
      </tr>
    </tbody>
  </table>
</form>
<table class="table no-bordered no-wrap-label" *ngIf="!isEditting"  [class.child-mode]="childMode">
  <tbody>
    <tr>
      <td class="text-grey header">Email</td>
      <td class="text-white value">
        {{addressInfo?.email}}
     </td>
    </tr>
    <tr>
      <td class="text-grey header">UserName</td>
      <td class="text-white value">
        <div class="row">
          <div class="col-auto" >{{addressInfo?.firstName |uppercase}}</div>
          <div class="col-auto" *ngIf="addressInfo?.country!=='JP'">{{addressInfo?.middleName |uppercase}}</div>
          <div class="col-auto" >{{addressInfo?.lastName |uppercase}}</div>
        </div>
      </td>
    </tr>
    <tr *ngIf="addressInfo?.country === 'JP'">
      <td class="text-grey header">Japanese Name</td>
      <td class="text-white value">
        <div class="row">
          <div class="col-auto" >{{addressInfo?.firstNameJP}}</div>
          <div class="col-auto" >{{addressInfo?.lastNameJP}}</div>
        </div>
      </td>
    </tr>
    <tr>
      <td class="text-grey header">Phone No.</td>
      <td class="text-white value">{{addressInfo?.phone}}</td>
    </tr>
    <tr>
      <td class="text-grey header">DOB</td>
      <td class="text-white value">{{getDate(addressInfo?.dob)}}</td>
    </tr>
    <tr>
      <td class="text-grey header">Gender</td>
      <td class="text-white value">{{addressInfo?.gender == "1"?'Male':"Female"}}</td>
    </tr>
    <tr>
      <td class="text-grey header">Country</td>
      <td class="text-white value">{{addressInfo?.countryName }}</td>
    </tr>
    <tr>
      <td class="text-grey header">Postal/Zip Code</td>
      <td class="text-white value">{{addressInfo?.zipCode}}</td>
    </tr>
    <tr>
      <td class="text-grey header">Province/City</td>
      <td class="text-white value">{{addressInfo?.city}}</td>
    </tr>
    <tr>
      <td class="text-grey header">Street</td>
      <td class="text-white value">{{addressInfo?.street}}</td>
    </tr>
    <tr>
      <td class="text-grey header">Address</td>
      <td class="text-white value">{{addressInfo?.address}}</td>
    </tr>
    <tr>
      <td class="text-grey header">Building Name</td>
      <td class="text-white value">{{addressInfo?.building}}</td>
    </tr>
  </tbody>
</table>
